import axios from "axios";
import querystring from "querystring";
import { shopifyServiceBaseUrl } from "../../core/config";

import validateRequest from "./validateRequest";

const post = async ({
  endpoint,
  gatewayName = "",
  token,
  query = {},
  body = {},
}) => {
  const { isValid, errorMessage } = validateRequest(endpoint);

  if (!isValid) {
    throw new Error(errorMessage);
  }

  const endpointWithQuery = query
    ? `${endpoint}/${gatewayName}?${querystring.stringify(query)}`
    : `${endpoint}/${gatewayName}`;

  const response = await axios.post(endpointWithQuery, body, {
    baseURL: `${shopifyServiceBaseUrl}`,
    headers: {
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
  });

  if (response.status !== 200) {
    throw new Error(`Request failed with status ${response.status}`);
  }

  return response?.data;
};

export default post;
